<script>
import formCreate from '@/components/iglobalwin/formPanelGroups/index.js';
import formComponents from '@/components/iglobalwin/formComponents/common/index.js';
import googleads from '@/backend/services/googleAds/googleAds.js';
// import utils from '@/utils';
import {
	requiredCustomVm,
} from '@/utils/validate';

const {
	skyRadioBtn,
	skySlogan,
	selectProductDetail
} = formComponents;

function isEditPage(vm) {
	const edit = vm.$route.query.edit;
	const isEdit = edit !== null && edit !== undefined;
	return isEdit;
}

function getGroups(pageData, vm) {
	let { isEdit, domain } = pageData;

	return {
		date: {
			title: '设置广告',
			items: {
				box: {
					label: '',
					onChange: valueChange,
				},
				tips: {
					label: '',
					type: selectProductDetail,
					value: [],
					domain: domain,
					visable(vm) {
						return !isEdit;
					},
				},
				adDto: {
					label: '',
					type: skySlogan,
					value: {
						headlines: [],
						descriptions: [],
						finalUrls: ''
					},
					domain: domain || '',
					productUrl: '',
					isValidate: isEdit ? true : false,
					changeVal: (res) => {
						changeVal(res, vm)
					},
					aiWrite: (list) => {
						aiWrite(list, vm)
					},
					rules: [
						// required('请设置时间段'),
						requiredCustomVm('请检查广告输入内容是否正确', function(val, vm) {
							return vm.formData.fields.adDto.isValidate;
						})
					],
				}
			}
		},
		// fujia: {
		// 	title: '附加信息',
		// 	items: {
		// 		status: {
		// 			label: '默认状态',
		// 			type: skyRadioBtn,
		// 			value: 'ENABLED',
		// 			options: [
		// 				{
		// 					name: '启用',
		// 					code: 'ENABLED',
		// 				},
		// 				{
		// 					name: '暂停',
		// 					code: 'PAUSED',
		// 				},
		// 			],
		// 			// code: 'CampaignPlanType',
		// 			rules: [required('请选择默认状态')],
		// 		},
		// 	}
		// }
	};
}

// 预加载数据
async function pageData(vm) {
	const isEdit = isEditPage(vm);
	const domain = await getServiceDomain(); // 获取服务单域名
	if (isEdit) {
		const detail = await getAdgroupadEditDetail(vm); //获取广告修改详情
		return {
			isEdit,
			domain,
			detail,
		};
	} else {
		return {
			isEdit,
			domain
		};
	}
}

function getFormData({ pageData }, vm) {
	let { isEdit, detail } = pageData;
	const groups = getGroups(pageData, vm);
	if (isEdit) {
		return SetGroupFormValue(groups, detail);
	} else {
		return groups;
	}
}
// 编辑表单时value值回显填入
function SetGroupFormValue(groups, obj) {
	Object.keys(groups).forEach(groupKey => {
		Object.keys(groups[groupKey].items).forEach(itemKey => {
			// 如果obj[itemKey]不存在或者为空值时，表单则取自己原来的默认值。
			groups[groupKey].items[itemKey].value = obj[itemKey] || groups[groupKey].items[itemKey].value;
		});
	});
	return groups;
}

// 处理表单变化
async function valueChange(vm, field) {
	if(vm.errorMsgList && vm.errorMsgList.length) {
		vm.validateAll().then(msg => {
			vm.errorMsgList = msg;
		})
	}
	if(field.itemName === 'tips') {
		// 获取产品链接
		vm.formData.fields.adDto.productUrl = field.value;
	}
}

function changeVal(val,vm) {
	// 校验广告语规则是否成功
	vm.formData.fields.adDto.isValidate = val;
}

function aiWrite(val,vm) {
	// ai撰写
	vm.formData.fields.tips.value = val;
}
let resourceName = ''; // 广告编辑时 广告的资源名称
// 获取广告组详情数据
async function getAdgroupadEditDetail(vm) {
	const res = await googleads.getAdgroupadEditDetail(vm.$route.query.edit);
	resourceName = res.data.resourceName;
	let data = {
			'adDto': {
				finalUrls: res.data.finalUrls[0] || '',
				headlines: res.data.titles,
				descriptions: res.data.titlesDece,
			}
	};
	return data;
}

// 获取服务单域名
async function getServiceDomain(obj) {
	let res = await googleads.getServiceDomain();
	return res.data;
};

// 提交
async function submit(data) {
	const isEdit = this.$route.query.edit;
	let res;
	delete data['box'];
	delete data['tips'];
	if(isEdit) {
		// 编辑
		data['resourceName'] = resourceName;
		data['titls'] = data.adDto.headlines;
		data['titlsDesc'] = data.adDto.descriptions;
		data['finalUrl'] = data.adDto.finalUrls;
		delete data['adDto'];
		res = await googleads.getAdgroupadUpdate(data);
	}else {
		// 新建
		data['adGroup'] = this.$route.query.resourceName;
		res = await googleads.addAdgroupad(data);
	}
	goBack(this,res);
	if(res.status == 200 && !res.data.error) {
		this.$message.success(isEdit ? '编辑广告成功！' :　'新建广告成功！');
	}else {
		this.$message.error(isEdit ? '编辑广告失败！' : '新建广告失败！');
	}
}

function titleTooltipInfo() {
	return {
		tit: isEditPage(this) ? '编辑广告' : '新建广告',
		// tip: [],
		item: {
			'所属广告系列': this.$route.query.adSeriesName + '（ID：'+this.$route.query.adSeriesId+'）',
			'所属广告组': this.$route.query.adGroupName + '（ID：'+this.$route.query.adGroupId+'）',
		}
	};
}

// 返回
function goBack(vm, res) {
	// 确认后返回广告列表，选中父级广告组
	vm.$router.push({
		name: 'accountManagement',
		query: {
			adSeriesId: vm.$route.query.adSeriesId,
			adSeriesName: vm.$route.query.adSeriesName,
			adGroupId: vm.$route.query.adGroupId,
			adGroupName: vm.$route.query.adGroupName,
			resourceName: vm.$route.query.resourceName,
		},
	});
}

// 取消-返回
function cancel(vm) {
	vm.$confirm('将不保存已填写的内容,确认后返回广告列表，选中父级广告组', '提示', {
		confirmButtonText: '确定',
		cancelButtonText: '取消',
		type: 'warning',
	})
		.then(() => {
			goBack(vm);
		})
		.catch(() => {
			return;
		});
}

export default formCreate({
	getFormData,
	load: {
		pageData,
	},
	submit,
	cancel,
	showNavPanel: true,
	goBack,
	labelWidth: '180px',
	titleTooltip: true,
	titleTooltipInfo,
});
</script>
